import { useState, useEffect } from 'react';
import { supabase, ADMIN_EMAIL } from '../lib/supabase';

export function useAuth() {
  const [session,      setSession]      = useState(undefined);
  const [isAdmin,      setIsAdmin]      = useState(false);
  const [authChecking, setAuthChecking] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError,   setLoginError]   = useState('');

  const checkAdmin = async (sess) => {
    setAuthChecking(true);
    try {
      if (ADMIN_EMAIL && sess.user.email === ADMIN_EMAIL) {
        setIsAdmin(true); setAuthChecking(false); return;
      }
      const { data } = await supabase.from('admin_users').select('id')
        .eq('user_id', sess.user.id).single();
      setIsAdmin(!!data);
    } catch {
      setIsAdmin(ADMIN_EMAIL ? sess.user.email === ADMIN_EMAIL : false);
    }
    setAuthChecking(false);
  };

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session: sess } }) => {
      setSession(sess);
      if (sess) checkAdmin(sess);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, sess) => {
      if (event === 'TOKEN_REFRESH_FAILED' || event === 'SIGNED_OUT') {
        setSession(null); setIsAdmin(false);
      } else {
        setSession(sess);
        if (sess) checkAdmin(sess);
        if (!sess) setIsAdmin(false);
      }
    });
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
    return () => subscription.unsubscribe();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLogin = async () => {
    setLoginLoading(true); setLoginError('');
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin, queryParams: { access_type: 'offline', prompt: 'consent' } },
    });
    if (error) { setLoginError(error.message); setLoginLoading(false); }
  };

  const handleLogout = () => supabase.auth.signOut();

  return { session, isAdmin, authChecking, loginLoading, loginError, handleLogin, handleLogout };
}
